import {NavLink} from "react-router-dom";
import './Home.css'
import {HelpAbility} from "helpers/HelpAbility";
import C from "helpers/HelpConstants";

const AppLog = () => {
    let myAbilities = HelpAbility();
    return (
        <div className="container">
            <div className="row no-gutters my-md-4">
                <div className="col-md-12 col-xs-12 ">
                    <h4 className="text-center" style={{color: '#009CDD'}}>Bienvenidos al Sistema de</h4>
                    <h2 className="text-center text-uppercase" style={{color: '#009CDD'}}>Procesamiento de Logs</h2>
                    <div className="row">
                       
                        {(myAbilities.has(C.A.PROCESSLOG.CREATE) && myAbilities.hasRol(C.R.SOPORTE)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/processlog">
                                <div className="card card-custom">
                                    <img src="/img/log-file.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Procesar Log</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.PROCESSLOG.LIST) && myAbilities.hasRol(C.R.SOPORTE)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/logs">
                                <div className="card card-custom">
                                    <img src="/img/log-files.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Ver Logs</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.PROCESSLOG.CREATE) && myAbilities.hasRol(C.R.SOPORTE)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/historial">
                                <div className="card card-custom">
                                    <img src="/img/historial.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Historial de Logs</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.ERROR.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/asignaciones">
                                <div className="card card-custom">
                                    <img src="/img/asignaciones.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Mis Asignaciones</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.FLUJO.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/flujos">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Flujos de Estado</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.PROYECTO.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/proyectos">
                                <div className="card card-custom">
                                    <img src="/img/proyectos.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Proyectos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p><strong>Objetivo Principal</strong></p>
                            <p>Consolidar conocimientos en ReactJs y NodeJs</p>
                            <p><strong>Objetivos Especificos</strong></p>
                            <ul>
                                <li>Gestionar los parámetros de los servicios registrados</li>
                                <li>Gestionar Permisos para la administración de servicios</li>
                            </ul>
                        </div>
                        {false && <div className="col-sm-6">
                            <p><strong>Próximamente...</strong></p>
                            <ul>
                                <li>Gestión de Clientes</li>
                                <li>Gestión de Lineas</li>
                                <li>Gestión de Permisos</li>
                            </ul>
                        </div>}
                    </div>
                </div>

                <div className="col-md-12 col-xs-12 ">
                    <div className="row">
                        <div className="col-sm-6">
                            <p className="text-center"><strong>Arquitectura Inicial</strong></p>
                            <img src="/img/AS-IS.PNG" className="img-fluid-noexiste" alt="Arquitectura Inicial"/>
                        </div>
                        <div className="col-sm-6">
                            <p className="text-center"><strong>Arquitectura Actual</strong></p>
                            <img src="/img/TO-BE.PNG" className="img-fluid-noexiste" alt="Arquitectura Actual"/>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}
export default AppLog;